var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPanelActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 2,
    viewBox: "0 0 16 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.5C1.27614 0.5 1.5 0.723858 1.5 1C1.5 1.27614 1.27614 1.5 1 1.5C0.723858 1.5 0.5 1.27614 0.5 1C0.5 0.723858 0.723858 0.5 1 0.5ZM8 0.5C8.27614 0.5 8.5 0.723858 8.5 1C8.5 1.27614 8.27614 1.5 8 1.5C7.72386 1.5 7.5 1.27614 7.5 1C7.5 0.723858 7.72386 0.5 8 0.5ZM15 0.5C15.2761 0.5 15.5 0.723858 15.5 1C15.5 1.27614 15.2761 1.5 15 1.5C14.7239 1.5 14.5 1.27614 14.5 1C14.5 0.723857 14.7239 0.5 15 0.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPanelActions);
export default __webpack_public_path__ + "static/media/admin_panel_actions.fd05da8bc2539718fdb7b3e7e26df531.svg";
export { ForwardRef as ReactComponent };